<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="app-screen">
    <AppScreensStatusBar :time="t('mock.statusTime')" />

    <div class="app-bar">
      <div class="app-bar__back">‹</div>
      <div class="app-bar__title">{{ t('mock.echo.title') }}</div>
      <div class="app-bar__action app-bar__action--green">👤</div>
      <div class="app-bar__action">↻</div>
    </div>

    <div style="font-size: 9.5px; color: var(--app-text-dim); line-height: 1.45; margin-bottom: 10px;">
      {{ t('mock.echo.lede') }}
    </div>

    <!-- Signatures card -->
    <div class="app-card" style="margin-bottom: 8px;">
      <div class="app-card__title">{{ t('mock.echo.sigTitle') }}</div>
      <div class="app-sigrow">
        <span class="app-sigrow__dot app-sigrow__dot--green" />
        <span class="app-sigrow__name">{{ t('mock.echo.sigTrustee') }}</span>
        <span class="app-sigrow__state">· {{ t('mock.echo.sigTrusteeOk') }}</span>
        <span class="app-sigrow__check">✓</span>
      </div>
      <div class="app-sigrow">
        <span class="app-sigrow__dot app-sigrow__dot--green" />
        <span class="app-sigrow__name">{{ t('mock.echo.sigEcho') }}</span>
        <span class="app-sigrow__state">· {{ t('mock.echo.sigEchoOk') }}</span>
        <span class="app-sigrow__check">✓</span>
      </div>
      <div class="app-sigrow">
        <span class="app-sigrow__dot" />
        <span class="app-sigrow__name" style="color: var(--app-text-dim);">{{ t('mock.echo.sigAgent') }}</span>
        <span class="app-sigrow__state">· {{ t('mock.echo.sigAgentRdy') }}</span>
      </div>
    </div>

    <!-- 100% progress -->
    <div class="app-card app-card--green" style="margin-bottom: 8px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; font-size: 10.5px; font-weight: 700;">
        <span style="color: var(--app-green);"><span style="padding: 2px 6px; border: 1px solid var(--app-green); border-radius: 4px;">{{ t('mock.echo.progLbl') }}</span></span>
        <span style="color: var(--app-green); font-family: ui-monospace, monospace;">100%</span>
      </div>
      <div class="app-progress">
        <div class="app-progress__fill app-progress__fill--green" style="width: 100%;" />
      </div>
    </div>

    <!-- Echo received card -->
    <div class="app-card app-card--green">
      <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px;">
        <span style="color: var(--app-green);">📡</span>
        <span style="padding: 1px 6px; border: 1px solid var(--app-green); border-radius: 4px; font-size: 10px; color: var(--app-green); font-weight: 700;">{{ t('mock.echo.received') }}</span>
      </div>
      <div style="font-size: 9.5px; color: var(--app-text); line-height: 1.4;">
        {{ t('mock.echo.receivedHint') }}
      </div>
    </div>

    <div style="margin-top: auto;">
      <button class="app-btn app-btn--green">
        <span>✎</span><span>{{ t('mock.echo.sign') }}</span>
      </button>
    </div>
  </div>
</template>
